<template>
  <el-container id='wrapper'>
    <el-header>
      <PageTitle title="Manage Users" disableDateTime></PageTitle>
    </el-header>
    <el-main class="main">
      <div class="container">
        <UsersTable></UsersTable>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageTitle from '../components/PageTitle'
import UsersTable from '@/components/UsersTable'

export default {
  components: {
    PageTitle,
    UsersTable
  },
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {

  },

  watch: {

  }
}
</script>

<style lang='scss' scoped>
@import "../styles/common.scss";
.main {
  display: flex;
  align-items: stretch;
  padding-top: 0px;

  .container {
    display: flex;
    flex-grow: 1;
    align-items: stretch;
    background-color: white;
    border-radius: 10px;
  }
}
</style>
